import React, { FormEvent, useState, useEffect} from 'react'
import { Col, Form, FormGroup, Input, Label } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Btn, H2, H6, Image, P } from '../AbstractElements';
import { dynamicImage } from '../Utils';
import { CreateAccount, DontHaveAccount, EmailAddress, ForgotPassword, Password, RememberPassword, SignIn, SignInAccount, SignInWith } from '../Utils/Constants';
import SocialLink from './SocialLink';
import { postJson } from "../hook/request";
import RecoverForm from "./RecoverForm";


type LoginResponse = {
    created: {
        fullname: string;
        token: string;
        data: string; 
        codiceUtente: string; 
        tipo: string; 
    };
};

export default function SignInForm() {
    const navigate = useNavigate();
    const [isPasswordVisible, setPasswordVisible] = useState(false);
    const [username, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const toggle = () => setPasswordVisible(!isPasswordVisible);
    const [recover, setRecover] = useState(false);


    useEffect(()=>{
        const message  = localStorage.getItem('messageError');
        if(message){
            toast.error(message);
        }
        localStorage.clear();
    },[])

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            const { data } = await postJson<LoginResponse>("/login", { username, password });
            const token = data?.created?.token ?? null;
            const fullname = data?.created?.fullname ?? "";
            const createdAtStr = data?.created?.data ?? null;
            const codiceUtente = data?.created?.codiceUtente ?? null;
            const tipo = data?.created?.tipo ?? null;

            if (!token) {
                toast.error("Credenziali non valide o errore server.");
                return;
            }
            const createdAtIso =
                createdAtStr
                    ? new Date(createdAtStr.replace(" ", "T") + ":00").toISOString()
                    : new Date().toISOString();
            localStorage.setItem("token", token);
            localStorage.setItem("email", username);
            localStorage.setItem("login", "true");
            localStorage.setItem("user_fullname", fullname);
            localStorage.setItem("login_at", createdAtIso);
            localStorage.setItem("codiceUtente", codiceUtente);
            localStorage.setItem("tipo", tipo);

            toast.success(`Benvenuto${fullname ? `, ${fullname}` : ""}!`);
            navigate(`/dashboard/default`);
        } catch (err: any) {
            const msg =
                err?.response?.data?.message ||
                err?.message ||
                "Credenziali non valide o errore server.";
            toast.error(msg);
        }
    };


    const handleRecover = () => {
        setRecover(true);
    };


    if (recover) {
        return (
        <RecoverForm
            email={username}
            onBack={() => setRecover(false)} // per tornare al login
        />
        );
    }
    

    return (
        <div>
            <div>
                {/* <Link className='logo' to={`${process.env.PUBLIC_URL}/dashboard/default`}>
                    <Image className="img-fluid for-light m-auto" src={dynamicImage(`logo/logo1.png`)} alt="looginpage" />
                    <Image className="img-fluid for-dark" src={dynamicImage(`logo/logo-dark.png`)} alt="looginpage" />
                </Link> */}
            </div>
            <div className="login-main">
                <Form className="theme-form" onSubmit={handleSubmit}>
                    <H2 className="text-center">Accedi al tuo account</H2>
                    <P className="text-center">{"Inserisci email e password"}</P>
                    <FormGroup>
                        <Col><Label>{EmailAddress}</Label></Col>
                        <Input type="email" defaultValue={username} onChange={(event) => setEmail(event.target.value)} />
                    </FormGroup>
                    <FormGroup>
                        <Col><Label>{Password}</Label></Col>
                        <div className="form-input position-relative">
                            <Input type={isPasswordVisible ? 'text' : 'password'} defaultValue={password} onChange={(event) => setPassword(event.target.value)} name="login[password]" />
                            <div className='show-hide' onClick={toggle}>
                                <span className={!isPasswordVisible ? 'show' : ''}></span>
                            </div>
                        </div>
                    </FormGroup>
                    <FormGroup className="mb-0 checkbox-checked">
                        <FormGroup className="checkbox-solid-info" check>
                            <Input id="checkbox1" type="checkbox" />
                            <Label htmlFor="checkbox1" check>{RememberPassword}</Label>
                        </FormGroup>
                        <div style={{cursor:'pointer'}} className="link my-2" onClick={handleRecover}>Recupera Password</div>
                        <div className="text-end mt-3">
                            <Btn color='primary' className="w-100" block>{SignIn}</Btn>
                        </div>
                    </FormGroup>
                    {/* <div className="login-social-title"><H6>{SignInWith}</H6></div> */}
                    {/* <SocialLink />
                    <P className="mt-4 mb-0 text-center">{DontHaveAccount}
                        <Link className="ms-2" to={`${process.env.PUBLIC_URL}/authentication/register_simple`}>{CreateAccount}</Link>
                    </P> */}
                </Form>
            </div>
        </div>
    )
}